export default "__VITE_ASSET__a6d05555__"